import { Vector2Tuple } from 'three';

/**
 * The node types for the shallow graph
 *
 * @note 0 reserved for root node
 * @note 31 max value for node type
 */
export enum FShallowNodeTypesEnum {
  Root = 0,
  Furniture = 1,
  Decoration = 2,
  FComposition = 3,
  FPolygon = 4,
  FGroup = 5,
  FArea = 6,
  Measurement = 7,
  Annotation = 8,
  FOverride = 31,
}

export interface FShallowBase {
  type: FShallowNodeTypesEnum;
}
export interface FShallowGraph extends FShallowBase {
  type: FShallowNodeTypesEnum.Root;
  name: string | null;
  space: number;
  cursor: string | null;
  version: string;
  nodes: {
    [selector: string]: FShallowNode;
  };
}
export interface FShallowNodeBase extends FShallowBase {
  type: FShallowNodeTypesEnum;
  position?: Vector2Tuple;
  positionY?: number;
  rotation?: number;
  parent?: string;
  // TODO this must be removed treate in the state
  meta?: Record<string, any>;
}

/**
 * Node for override
 */
export interface FOverrideShallowNode extends FShallowNodeBase {
  type: FShallowNodeTypesEnum.FOverride;
  visible?: boolean;
}
export interface FurnitureShallowNode extends FShallowNodeBase {
  type: FShallowNodeTypesEnum.Furniture;
  id: number;
  visible?: boolean;
}

export interface DecorationShallowNode extends FShallowNodeBase {
  id: number;
  type: FShallowNodeTypesEnum.Decoration;
  visible?: boolean;
}

export interface FCompositionShallowNode extends FShallowNodeBase {
  type: FShallowNodeTypesEnum.FComposition;
  id: number;
  attrs?: Record<string, any>;
}

export interface FPolygonShallowNode extends FShallowNodeBase {
  type: FShallowNodeTypesEnum.FPolygon;
  id: number;
  points: Vector2Tuple[];
  attrs?: Record<string, any>;
}

export interface FAreaShallowNode extends FShallowNodeBase {
  type: FShallowNodeTypesEnum.FArea;
  points?: Vector2Tuple[];
}

export interface MeasurementShallowNode extends FShallowNodeBase {
  type: FShallowNodeTypesEnum.Measurement;
  points?: Vector2Tuple[];
}

export interface AnnotationShallowNode extends FShallowNodeBase {
  type: FShallowNodeTypesEnum.Annotation;
  text?: string;
}

export interface FGroupShallowNode {
  type: FShallowNodeTypesEnum.FGroup;
}

export type FShallowNode =
  | FurnitureShallowNode
  | DecorationShallowNode
  | FCompositionShallowNode
  | FPolygonShallowNode
  | FGroupShallowNode
  | FAreaShallowNode
  | MeasurementShallowNode
  | AnnotationShallowNode
  | FOverrideShallowNode;

export type FShallowNodeWithSelector = FShallowNode & { selector: string };
